import React, { useEffect, useState, useCallback } from "react";
import API, { CONFIG, UPDATE_CONFIG } from "../../network/api";
import { TEXT_DEF } from "../../constant/text";
import { Button, message } from "antd";
import ModalCommon from "../../components/Modal";
import RichTextEditor from "../../components/RichTextEditor";

const SetupRule = () => {
    const [loaded, setLoaded] = useState(false);
    const [isShowModalConfirm, setIsShowModalConfirm] = useState(false);
    const [isShowModalSuccess, setIsShowModalSuccess] = useState(false);
    const [messageApi, contextHolder] = message.useMessage();

    /** Giữ nguyên từ API khi lưu (không còn chỉnh trên UI) */
    const [rules, setRules] = useState("");
    const [term1, setTerm1] = useState("");

    const getDataConfig = useCallback(async () => {
        try {
            const res = await API.get(`${CONFIG}`);
            const data = res.data?.data || res.data;
            const terms = data?.terms || {};

            setRules(data?.rules || "");
            setTerm1(terms?.term1 || "");
            setLoaded(true);
        } catch (err) {
            console.log(err);
            messageApi.error("Không thể tải dữ liệu cấu hình");
        }
    }, [messageApi]);

    useEffect(() => {
        getDataConfig();
    }, [getDataConfig]);

    const handleUpdateConfig = async () => {
        try {
            setIsShowModalConfirm(false);

            const body = {
                config: {
                    rules,
                    terms: {
                        term1,
                    },
                },
            };

            await API.patch(`${UPDATE_CONFIG}`, body);
            setIsShowModalSuccess(true);

            setTimeout(() => {
                getDataConfig();
            }, 1000);
        } catch (err) {
            console.log(err);
            messageApi.error(err?.response?.data?.message || "Cập nhật thất bại");
            setIsShowModalSuccess(false);
        }
    };

    const handleShowModal = () => {
        setIsShowModalConfirm(true);
    };

    return (
        <div className="col-12">
            {contextHolder}
            {loaded && (
                <div className="col-12">
                    <div className="flex w-full">
                        <div className="flex flex-col w-full items-center justify-center">
                            <div className="col-10 mt-2 flex flex-col items-center justify-center">
                                <div className="flex w-full items-start" style={{ marginBottom: "32px" }}>
                                    <div className="flex w-[20%] justify-end mr-10 pt-2">Thể lệ:</div>
                                    <div className="w-[60%]">
                                        <RichTextEditor
                                            value={term1 || ""}
                                            onChange={(value) => setTerm1(value || "")}
                                            placeholder="Nhập thể lệ..."
                                            height={200}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="col-10 mt-5 flex items-center justify-center">
                                <Button type="primary" onClick={handleShowModal}>
                                    Cập nhật
                                </Button>
                            </div>
                        </div>
                    </div>
                </div>
            )}
            {isShowModalConfirm && (
                <ModalCommon
                    isShow={isShowModalConfirm}
                    message={TEXT_DEF.text0062}
                    txtBtnAcc={TEXT_DEF.text0008}
                    textBtnClose={TEXT_DEF.text0023}
                    actionNext={handleUpdateConfig}
                    close={() => setIsShowModalConfirm(false)}
                />
            )}
            {isShowModalSuccess && (
                <ModalCommon
                    isShow={isShowModalSuccess}
                    message={TEXT_DEF.text0063}
                    txtBtnAcc={TEXT_DEF.text0007}
                    actionNext={() => {
                        setIsShowModalSuccess(false);
                        getDataConfig();
                    }}
                    close={() => {
                        setIsShowModalSuccess(false);
                        getDataConfig();
                    }}
                />
            )}
        </div>
    );
};

export default SetupRule;
